import { useEffect, useState } from 'react';

export const useScreenSize = () => {
  const [screen, setScreen] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    isLargeDesktop: false,
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      setScreen({
        isMobile: width <= 576,
        isTablet: width <= 1024,
        isDesktop: width > 1024 && width < 1440,
        isLargeDesktop: width >= 1680,
        width,
      });
    };

    handleResize(); // initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screen;
};
